import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FiPlus, FiClock, FiTarget } from 'react-icons/fi';
import './FloatingAddMenu.css';

export default function FloatingAddMenu({ quickAddRoutes = { study: '/study-time', goal: '/goals' } }) {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // Dışarı tıklayınca menüyü kapat
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleMenu = () => setIsOpen((prev) => !prev);

  const handleNavigate = (path) => {
    setIsOpen(false);
    navigate(path);
  };

  return (
    <div className="fab-container" ref={menuRef}>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            key="fab-menu"
            className="fab-menu"
            initial={{ opacity: 0, y: 20, scale: 0.8 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.8 }}
            transition={{ duration: 0.2, type: 'spring', stiffness: 200, damping: 20 }}
          >
            <button className="fab-item" onClick={() => handleNavigate(quickAddRoutes.study)}>
              <span className="fab-label">Çalışma Başlat</span>
              <div className="fab-icon-wrapper">
                <FiClock size={18} />
              </div>
            </button>
            <button className="fab-item" onClick={() => handleNavigate(quickAddRoutes.goal)}>
              <span className="fab-label">Hedef Ekle</span>
              <div className="fab-icon-wrapper">
                <FiTarget size={18} />
              </div>
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        className={`fab-main-btn ${isOpen ? 'fab-main-btn--open' : ''}`}
        onClick={toggleMenu}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <motion.div
          animate={{ rotate: isOpen ? 45 : 0 }}
          transition={{ duration: 0.2 }}
        >
          <FiPlus size={24} />
        </motion.div>
      </motion.button>
    </div>
  );
}
